export default __webpack_public_path__ + "static/media/video.8c052855.mp4";